import { CANADA, en_CA, en_PR, en_US, es_PR, es_US, fr_CA, LocaleCodes, PUERTO_RICO, UNITED_STATES } from "../app-consts/appConstants";

export const isCanadianLocale = (locale: LocaleCodes) => locale === en_CA || locale === fr_CA;


export type LocationCode = typeof UNITED_STATES | typeof CANADA | typeof PUERTO_RICO;

export const getLocationCodeFromUrl = (
  url: string = window.location.href
): LocationCode => {
  if (url.includes('_PR')) {
    return PUERTO_RICO;
  }
  if (url.includes('_CA')) {
    return CANADA;
  }
  return UNITED_STATES;
}

const ENGLISH_LOCALES = [en_CA, en_US, en_PR];

export const isEnglishLocale = (locale: LocaleCodes): boolean => {
  return ENGLISH_LOCALES.includes(locale);
};